export default __webpack_public_path__ + "assets/images/d8dd6679ebecefb4d97cd9774fa14c19.png";